import { Menu, Grid } from "@mui/material";
import makeStyles from '@mui/styles/makeStyles';
import { styled } from "@mui/material/styles";
import { HiChevronUp, HiChevronDown } from "react-icons/hi";

import Button, { Colors } from "../../../components/Form/Button";
import { TypographyButton } from "../../../components/SignUp/styled";

export const CompanyUserAndEmailWrapper = styled(Grid)(() => ({
  overflow: "hidden",
  textOverflow: "ellipsis",
}));

export const ProfileCompany = styled(Grid)(() => ({
  marginTop: "12px",
  display: "flex",
  alignItems: "center",
  gap: "8px",
}));

export const UserCompanyLogo = styled("img")(() => ({
  width: "20px",
  height: "20px",
  borderRadius: "50%",
}));

export const UserProfileSectionTitle = styled("div")(() => ({
  fontFamily: "Manrope",
  fontWeight: 500,
  fontSize: "10px",
  color: "#98A2B3",
  textTransform: "uppercase",
  marginBottom: "4px",
}));

export const ProfileCompanyOptionIconUp = styled(HiChevronUp)(() => ({
  marginLeft: "auto",
}));

export const ProfileCompanyOptionIconDown = styled(HiChevronDown)(() => ({
  marginLeft: "auto",
}));

export const Divider = styled("hr")(() => ({
  margin: "7px 0",
}));

export const SwitchCompanyOption = styled(Button)(() => ({
  padding: "0 !important",
}));

export const ButtonLink = styled(TypographyButton, {
  shouldForwardProp: (props) => props !== "isLogout",
})(({ isLogout }: { isLogout: boolean }) => ({
  backgroundColor: "#FFFFFF",
  display: "flex",
  alignItems: "center",
  gap: "10px",
  color: isLogout ? Colors.ERROR.background.hoverColor : Colors.NOT_SELECTED.text.color,
  fontFamily: "Manrope",
  fontWeight: 500,
  fontSize: "14px",
  "&:hover": {
    color: isLogout ? Colors.ERROR.background.hoverColor : "",
  },
}));

export const GridItemLink = styled(Grid, {
  shouldForwardProp: (props) => props !== "isLogout",
})(({ isLogout }: { isLogout: boolean }) => ({
  paddingTop: "5px",
  paddingBottom: isLogout ? 0 : "5px",
}));

export const CompanyProfileNameOption = styled("div", {
  shouldForwardProp: (props) => props !== "displayChevron" && props !== "hasIcon",
})(({ displayChevron, hasIcon }: { displayChevron: boolean; hasIcon: boolean }) => ({
  fontFamily: "Manrope",
  fontWeight: 500,
  fontSize: "14px",
  color: "#465869",
  // eslint-disable-next-line no-nested-ternary
  maxWidth: displayChevron ? "210px" : hasIcon ? "200px" : "240px",
  lineHeight: "21px",
  whiteSpace: "nowrap",
  overflow: "hidden",
  textOverflow: "ellipsis",
}));

export const GridItemContainer = styled(Grid)(() => ({
  padding: "24px",
}));

export const UserMenuIcon = styled("div")(() => ({
  width: "40px",
  height: "40px",
  borderRadius: "50%",
  position: "relative",
  cursor: "pointer",
}));

export const UserMenuIconImage = styled("img")(() => ({
  width: "40px",
  height: "40px",
  borderRadius: "50%",
  position: "absolute",
  transform: "translate(-50%, -50%)",
  top: "50%",
  left: "50%",
  bottom: 0,
  right: 0,
  objectFit: "cover",
}));

export const MenuOptions = styled(Menu)(() => ({
  "& .MuiPaper-root": {
    backgroundColor: "#FFFFFF",
    borderRadius: "12px",
    transform: "translateX(calc(-8% - 6px)) !important",
    boxShadow: "2px 1px 5px rgba(152, 162, 179, 0.15), 0px 4px 10px rgba(48, 140, 219, 0.05)",
  },
  "& .MuiList-padding": {
    padding: "0px",
  },
}));

export const UserProfileName = styled("p")(() => ({
  fontFamily: "Manrope",
  fontWeight: 700,
  fontSize: "16px",
  color: "#465869",
  margin: 0,
}));

export const UserProfileEmail = styled("div")(() => ({
  fontFamily: "Manrope",
  fontWeight: 500,
  fontSize: "14px",
  color: "#465869",
}));

export const UserProfileImage = styled("img")(() => ({
  width: "40px",
  height: "40px",
  borderRadius: "50%",
}));

export const UserProfileMenuHeader = styled(Grid)(() => ({
  backgroundColor: "#FFFFFF",
  boxShadow: "0px 1px 6px rgba(147, 169, 189, 0.1)",
  borderRadius: "12px",
  padding: "24px",
  gap: "24px",
}));

export const UserProfileMenu = styled(Menu)(() => ({
  "& .MuiPaper-root": {
    backgroundColor: "#FFFFFF",
    borderRadius: "12px",
    overflow: "visible",
    boxShadow: "2px 1px 5px rgba(152, 162, 179, 0.15), 0px 4px 10px rgba(48, 140, 219, 0.05)",
  },
  "& .MuiList-padding": {
    padding: "0px",
  },
}));

export const CompanyProfileName = styled("div")(() => ({
  fontFamily: "Manrope",
  fontWeight: 400,
  fontSize: "14px",
  lineHeight: "20px",
  color: "#667085",
}));

export const CompanyAndProfileNameContainer = styled("div")(() => ({
  display: "flex",
  flexDirection: "column",
  alignItems: "flex-start",
  flexWrap: "nowrap",
}));

export const CompanyMenuListContainer = styled(Grid, {
  shouldForwardProp(propName) {
    return propName !== "scroll";
  },
})(({ scroll }: { scroll: boolean }) => ({
  maxHeight: "278px",
  padding: "0px 10px 5px 0px",
  overflowY: scroll ? "scroll" : "hidden",
  display: "flex",
  flexDirection: "column",
  flexWrap: "initial",
  gap: "10px",
}));

const styles = makeStyles(() => ({
  menuPaperProps: {
    width: "320px",
    marginTop: "50px",
    marginLeft: "-17px",
  },
  menuOptionsPaperProps: {
    width: "320px",
  },
}));

export default styles;
